// Shared constants for the multi-step Claims Intake Form.

export const LOSS_TYPES = [
  'Auto Liability',
  'Physical Damage',
  'Cargo Damage',
  'Occupational Accident',
  'Workers Compensation',
];

/** Mapping from loss-type label to the boolean column key on the claim doc. */
export const LOSS_TYPE_KEYS = [
  ['al', 'Auto Liability'],
  ['pd', 'Physical Damage'],
  ['cd', 'Cargo Damage'],
  ['ocac', 'Occupational Accident'],
  ['wc', 'Workers Compensation'],
];

/** Base list of document checkboxes shown on Step 7. The CMV-only entry is
 * inserted conditionally — see `buildDocTypes(otherVehicle)` below. */
const DOC_TYPES_BASE = [
  'Pictures Of Vehicle / Property Damage(s)',
  'DL or CDL, Insurance, Registration of Other Vehicle',
  'Police Report # or Exchange Form',
  'Company Truck Reg., Lease Agreement, Rate Con., BOL',
  'Video Footage',
  'Drivers Written Statement',
  'Damage Repair Estimate(s)',
  'Other Supporting Docs',
  '"Log Books"',
  'Drug & Alcohol Test Results',
];

export function buildDocTypes(otherVehicle) {
  // Insert CMV-only doc type at index 2 when applicable
  if (otherVehicle === 'CMV') {
    return [
      DOC_TYPES_BASE[0],
      DOC_TYPES_BASE[1],
      'DOT#, Truck#, Plate#, Trailer# of Other CMV',
      ...DOC_TYPES_BASE.slice(2),
    ];
  }
  return DOC_TYPES_BASE;
}

/** Doc-type label → boolean column on the claim record. */
export const DOC_FIELD_MAP = {
  'Pictures Of Vehicle / Property Damage(s)': 'damage_pics',
  'DL or CDL, Insurance, Registration of Other Vehicle': 'other_vehicle_docs',
  'DOT#, Truck#, Plate#, Trailer# of Other CMV': 'other_cmv',
  'Police Report # or Exchange Form': 'pr_or_ef',
  'Company Truck Reg., Lease Agreement, Rate Con., BOL': 'our_truck_docs',
  'Video Footage': 'video_footage',
  'Drivers Written Statement': 'drivers_ws',
  'Damage Repair Estimate(s)': 'estimates',
  'Other Supporting Docs': 'other_docs',
  '"Log Books"': 'log_books',
  'Drug & Alcohol Test Results': 'da_test',
};

export const INITIAL_FORM_DATA = {
  company: '',
  dateOfLoss: '',
  lossTypes: [],
  faultOfDriver: '',
  driverName: '',
  driverPhone: '',
  truckNumber: '',
  trailerNumber: '',
  location: '',
  lossDescription: '',
  policeInvolved: '',
  citationIssued: '',
  policeReportNo: '',
  policeReportNotReady: false,
  otherVehicle: '',
  towAway: false,
  injury: false,
  fatality: false,
  uploadedFiles: [],
  selectedDocuments: [],
};

export const PROPER_FIELDS = ['driverName', 'location'];
export const SENTENCE_FIELDS = ['lossDescription'];

// Re-exported from the central helpers module so the intake/* files don't
// need to know which file owns the canonical implementation.
export { rawDigits, formatPhone } from '../../utils/claimHelpers';

export const localTodayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const isImageFile = (file) => file.type && file.type.startsWith('image/');
export const isPdfFile = (file) => file.type === 'application/pdf' || file.name.endsWith('.pdf');
